import { useMemo } from "react";
import { useIsClient } from "@bmi-digital/components/hooks";
import { PATHNAME_KEY } from "../constants/queryConstants";
import { useSiteContext } from "../components/Site";
import { getCorrectedPath } from "../utils/path";

type BackNavigation = string | undefined;

const useBackNavigation = (): BackNavigation => {
  const { countryCode } = useSiteContext();
  const { isClient } = useIsClient();

  return useMemo<BackNavigation>(() => {
    if (!isClient) {
      return;
    }

    const searchParams = new URLSearchParams(window.location.search);
    const paths = searchParams.getAll(PATHNAME_KEY);
    if (!paths.length) {
      return;
    }

    const correctedPaths = paths.map((path) => getCorrectedPath(path));
    const path = correctedPaths[0];
    if (!path) {
      return;
    }

    return path;
  }, [countryCode, isClient]);
};

export default useBackNavigation;
